export default __webpack_public_path__ + "static/media/arm.5274b33a.png";